import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    status: PropTypes.string
};

function StatusIcon(props) {
    let { status, icon, label } = props;
    let statusClass = status ? 'mfa-status-icon--' + status : '';

    return (
        <div className={'mfa-status-icon ' + statusClass}>
            <div className={'asc-icon asc-icon--' + icon + '--white'}>
                {status === 'complete' && (
                    <span className="mfa-status-checkmark asc-icon asc-icon--circle-check">
                        <span className="asc-hidden">Check Icon</span>
                    </span>
                )}
            </div>
            <p className="asc-secondary-text">{label}</p>
        </div>
    );
}

StatusIcon.propTypes = propTypes;
export default StatusIcon;
